var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stats-wrapper"},[_c('iframe',{attrs:{"border":"none","scrolling":"no","width":"100%","height":"6500","src":'https://s5.sir.sportradar.com/tipico/'+_vm.locale+'/match/'+_vm.match.rid}}),_vm._v(" "),_c('div',{staticClass:"MiniStatsSlider-styles-slide"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a92c6c0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sportsbook/widget/matchStats.vue
// module id = qlps
// module chunks = 0